// extracted by mini-css-extract-plugin
export default {"content":"upa-z","title":"vpa-z","subTitle":"wpa-z","banner":"xpa-z","productCardOverride":"ypa-z"};